@if(!isProduction){
    <div class="fixed top-4 right-4 z-50 rounded-full bg-slate-800/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-700 border border-slate-200 shadow-sm print:hidden">
        Entorno de desarrollo
    </div>
}

<loading [visible]="loading"></loading>

<main class="min-h-screen flex bg-[#F8FAFC] font-sans text-slate-900">
    <div class="m-auto w-full max-w-md p-6">

        <div class="text-center mb-8">
            <div
                class="inline-flex items-center justify-center w-16 h-16 bg-white border border-slate-200 rounded-2xl shadow-sm mb-4">
                <img src="logo.svg" class="h-10 w-10" alt="Logo">
            </div>
            <h1 class="text-3xl font-extrabold tracking-tight text-slate-900">Bienvenid@</h1>
            <p class="text-sm text-slate-500 mt-2">Introduce tus credenciales para acceder al ERP</p>
        </div>

        <form [formGroup]="login" (submit)="onSubmit()"
            class="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm flex flex-col gap-5">

            <div class="flex flex-col gap-1.5">
                <label class="text-xs font-bold uppercase tracking-wider text-slate-500 ml-1">Usuario o email</label>
                <div class="relative">
                    <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400">👤</span>
                    <input formControlName="user" type="text" autocomplete="username" autocapitalize="none"
                        spellcheck="false"
                        class="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all placeholder:text-slate-400 text-sm"
                        placeholder="usuario o nombre@empresa.com" required>
                </div>
            </div>

            <div class="flex flex-col gap-1.5">
                <div class="flex justify-between items-center">
                    <label class="text-xs font-bold uppercase tracking-wider text-slate-500 ml-1">Contraseña</label>
                    <a href="#" class="text-xs font-semibold text-blue-600 hover:text-blue-700">¿Olvidaste tu clave?</a>
                </div>
                <div class="relative">
                    <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400">🔒</span>
                    <input #passwordInput formControlName="password" type="password"
                        class="w-full pl-10 pr-10 py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all placeholder:text-slate-400 text-sm"
                        placeholder="••••••••" required>
                    <password-toggle [input]="passwordInput" />
                </div>
            </div>

            @if(error){
            <div
                class="flex items-center gap-2 p-3 bg-red-50 border border-red-100 rounded-lg animate-in fade-in slide-in-from-top-1">
                <span class="text-sm text-red-600 font-medium text-center w-full">Usuario/email o contraseña incorrectos</span>
            </div>
            }

            <button type="submit"
                class="cursor-pointer w-full py-3 px-4 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-lg shadow-sm transition-all active:scale-[0.98] mt-2">
                Iniciar Sesión
            </button>

        </form>

        <p class="text-center text-sm text-slate-500 mt-8">
            ¿Problemas de acceso?
            <a href="#" class="font-semibold text-slate-900 hover:underline">Contacta con soporte</a>
        </p>
    </div>
</main>